<sm-toolbar>
    <p-button *ngIf="!keptAlive" icon="fas fa-cog" label="Versuche Windows-Sitzung offenzuhalten" (onClick)="tryKeepAlive()"></p-button>
    <p-message *ngIf="keptAlive" severity="info" text="Es wird versucht, die Windows-Sitzung offenzuhalten. DocumentHandler-Server beenden, um das Offenhalten zu beenden" [escape]=false></p-message>
    <p-button icon="fas fa-cog" label="Aktiviere Deutsches Tastatur-Layout" (onClick)="setGermanKeyboard()"></p-button>
    <p-button icon="fas fa-cog" label="SimpleCrypto Encrypt" (onClick)="simpleCryptoEncrypt()"></p-button>
    <p-button icon="fas fa-cog" label="SimpleCrypto Decrypt" (onClick)="simpleCryptoDecrypt()"></p-button>
</sm-toolbar>
